var render, staticRenderFns
import script from "./DefinitionItem.vue?vue&type=script&lang=js&"
export * from "./DefinitionItem.vue?vue&type=script&lang=js&"
import style0 from "./DefinitionItem.vue?vue&type=style&index=0&id=6a433f48&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports